export enum I18nFields {
  Description = 'description',
  Names = 'names',
  Subjects = 'subjects',
  Messages = 'messages',
}
